import React, { PureComponent } from 'react';

import { Container, Dot } from './codeLoader.styles';

export class CodeLoader extends PureComponent {
  static propTypes = {};

  render() {
    return (
      <Container>
        <Dot />
        <Dot />
        <Dot />
      </Container>
    );
  }
}
